import React, { createContext, useContext, useRef } from 'react';
import _debounce from 'lodash/debounce';

const ScrollContext = createContext<{ scrollToTop: () => void } | undefined>(
  undefined,
);

export const ScrollProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  const scrollToTop = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const debouncedScrollToTop = _debounce(scrollToTop, 100);

  return (
    <ScrollContext.Provider value={{ scrollToTop: debouncedScrollToTop }}>
      <div className="fow-app" id="main-container" ref={containerRef}>
        {children}
      </div>
    </ScrollContext.Provider>
  );
};

export const useScroll = () => {
  const context = useContext(ScrollContext);
  if (!context) {
    throw new Error('useScroll must be used within a ScrollProvider');
  }
  return context;
};
